//
// wizard.js
// Dashkit module
//

import { Tab } from 'bootstrap';

const toggles = document.querySelectorAll('[data-toggle="wizard"]');

toggles.forEach(toggle => {
  toggle.addEventListener('click', function(e) {
    e.preventDefault();

    // Toggle new tab
    const tab = new Tab(toggle);

    tab.show();

    // Remove active state
    toggle.classList.remove('active');
  });
});


let hasSolutionHash = () => {
  let hasWizardSteps = document.getElementById("wizardStepsSolution");
  if( hasWizardSteps ){
    let urlHash = window.location.hash;
    if(urlHash) {
      let stepsTrigger = document.querySelector('a[href="' + urlHash + '"]');
      if( stepsTrigger ){
        let tab = new Tab(stepsTrigger);
        tab.show();
      }
    }        
  }
}
hasSolutionHash();
